import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import CopyIcon from '../assets/document_icon.svg';
import CheckIcon from '../assets/copy_icon.svg';

function CodeBlock({ language, value }) {
  return (
    <SyntaxHighlighter style={dark} language={language}>
      {value}
    </SyntaxHighlighter>
  );
}

function MarkdownComponent({ text, messageClass }) {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = (code, language) => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className={messageClass}>
      <ReactMarkdown
        children={text}
        components={{
          code({ node, inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || '');
            const language = match ? match[1] : '';

            return !inline && match ? (
              <div style={{ position: 'relative' }}>
                <div className='copy-button-container'>
                  <span style={{ marginBottom: '8px', marginLeft: '15px' }}>{language}</span>
                  <button className='copy-code-button' onClick={() => handleCopyClick(children, language)}>
                    {copied ? (
                      <>
                        <img src={CheckIcon} alt="Copied" className='copy-button-svg' style={{ width: '13px', height: '13px', marginRight: '5px', position: 'relative', top: '2px', filter: 'invert(1)' }} />
                        <span>Copied</span>
                      </>
                    ) : (
                      <>
                        <img src={CopyIcon} alt="Copy code" className='copy-button-svg' style={{ width: '13px', height: '13px', marginRight: '5px', position: 'relative', top: '2px', filter: 'invert(1)' }} />
                        <span>Copy code</span>
                      </>
                    )}
                  </button>
                </div>
                <CodeBlock language={language} value={String(children).replace(/\n$/, '')} {...props} />
              </div>
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
        }}
      />
    </div>
  );
}




export default MarkdownComponent;


